/* 布局 */
//前台
import Layout from "@views/layout";

const topicarticleRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
            path: "topicarticle",
            name: "TOPICARTICLE",
            meta: {
                title: "话题文章管理",
                sort: 1,
            },
            component: () => import("@views/business/topicarticle/index.vue"),
            redirect: {
                name: "TOPICARTICLE_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "TOPICARTICLE_LIST",
                    meta: {
                        title: "话题文章管理",
                        sort: 2,
                        keepAlive: true
                    },
                    component: () => import("@views/business/topicarticle/list.vue"),
                },
                {
                    path: "add",
                    name: "TOPICARTICLE_ADD",
                    meta: {
                        title: "新增话题文章",
                        // parentPath: '/business/topicarticle/list',
                        parentPath: '/business/post/list',
                        operate: true,
                    },
                    component: () => import("@views/business/topicarticle/form.vue"),
                },
                {
                    path: "edit",
                    name: "TOPICARTICLE_EDIT",
                    meta: {
                        title: "编辑话题文章",
                        // parentPath: '/business/topicarticle/list',
                        parentPath: '/business/post/list',
                        operate: true,
                    },
                    component: () => import("@views/business/topicarticle/form.vue"),
                },
                {
                    path: "add_email",
                    name: "TOPICARTICLE_ADDEMAIL",
                    meta: {
                        title: "邮件推送",
                        parentPath: '/business/topicarticle/list',
                        operate: true,
                    },
                    component: () => import("@views/business/topicarticle/emailForm.vue"),
                },
            ],
        },


    ],
};

export default topicarticleRouter;
